import React from 'react';
import { Heading, P, NavButtons } from './Shell';
import { TermsBlock } from './Fields';
import { PUBLIC_SITE_NAME } from '../../config/brand';

const Step1 = ({ data, setField, errors, onNext }) => (
  <div data-testid="onboarding-step-1">
    <div className="border-t border-white/70 pt-5">
      <Heading>Review and continue</Heading>
      <P>Message from {PUBLIC_SITE_NAME} Team,</P>
      <P>&nbsp;Please review and sign the following documents via {PUBLIC_SITE_NAME}:</P>
      <P>- Investment Agreement</P>
      <P>- Terms and Conditions</P>
      <Heading>Instructions</Heading>
      <P>Open the {PUBLIC_SITE_NAME} email link. Review each document carefully.<br />Follow the prompts to add your signature and date Please read the Electronic Record and Signature Disclosure.</P>
      <TermsBlock id="terms_intro" checked={data.terms_intro} onChange={(v) => setField('terms_intro', v)} error={errors.terms_intro} />
    </div>
    <NavButtons onNext={onNext} hasErrors={Object.keys(errors).length > 0} />
  </div>
);

export default Step1;
